<section class="container" id="sdc-login-sync-page">

  <div class="card">
    <div class="card-body">
      <h2>One Time Sign In</h2>
      <p style="text-align:left"> Please sign in using your internal Secure Data Commons credentials. Accounts only need to be linked once.</p>
      <hr>
        <div class="form">
          <input class="form-control mb-3" type="text" placeholder="Username" [(ngModel)]="username" [ngClass]="{ 'is-invalid': is_invalid == true }">

          <div class="input-group mb-3">
            <input class="form-control" [type]="show_password ? 'text' :  'password'" placeholder="Password" [(ngModel)]="password" [ngClass]="{ 'is-invalid': is_invalid == true }">
            <button class="btn btn-outline-secondary" type="button" id="button-addon2" (click)="show_password = !show_password">
              <i class="fa-solid " [ngClass]="show_password ? 'fa-eye' : 'fa-eye-slash' "></i>
            </button>
          </div>

          <button type="submit" class="btn btn-primary" [disabled]="username == undefined || password == undefined || is_loading == true" (click)="submit_login_sync()">

            @if (is_loading == true) {
              <i class="fa-solid fa-gear fa-spin"></i> Attempting to synchronize login....
            } @else {
              Attempt Login Sync
            }

          </button>
          @if (is_invalid == true) {
            <hr>
              <p class="text-center">Username or Password is Incorrect. </p>
              <p class="text-center"><small>If you continue to have issues logging in, please contact your administrator.</small></p>
            }
          </div>
          <hr>
            <p style="text-align:left"><strong>Need an account? </strong> Contact <a href="mailto:sdc-support@dot.gov" style="text-decoration: none">sdc-support&#64;dot.gov</a> to discuss your DOT research project and get started.</p>
            <p style="text-align:left">If you do not remember your Secure Data Commons credentials, please contact the <a href="mailto:sdc-support@dot.gov" style="text-decoration: none">Support Team.</a></p>

          </div>
        </div>
      </section>